// components
import { Points } from './points';
import { DescriptionMobile } from './description-mobile/description-mobile';
import { InnerHtml } from 'components/InnerHtml/inner-html';

// utils
import { truncateAtWordBoundary } from 'utils/truncate';
import { useTracking as useTracking2 } from '../../../utils/tracking/track';
import { trackInteractiveDescriptionInfoClick } from 'components/ContentElements/interactive-description/interactive-description';

interface InteractiveDescriptionMobileProps {
  border: string;
  title: string;
  infoText: string;
  sectionId?: string;
}

export function InteractiveDescriptionMobile({
  border,
  title,
  infoText,
  sectionId,
}: Readonly<InteractiveDescriptionMobileProps>) {
  const borderStyle = border === 'disable-border' ? `interactive-description--${border}` : '';

  const { trackClick } = useTracking2();

  return (
    <div className="grid-container" id={sectionId}>
      {title && <InnerHtml as="h1" content={title} />}
      <div className={`interactive-description grid-x ${borderStyle}`}>
        <div className="interactive-description__wrapper grid-x">
          <DescriptionMobile />
          <Points />
          {infoText && (
            <div className="interactive-description__info">
              <button tabIndex={0} onClick={trackInteractiveDescriptionInfoClick(trackClick)}>
                <i className="icon web20-icon web20-icon-info-circle-full" />
              </button>
              <span>{truncateAtWordBoundary(infoText, 50)}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
